import { ISolicitudChofer } from "../interfaces/solicitud/ISolicitudVehiculoModel";


export class ChoferModel implements ISolicitudChofer {
    
    apellidoPaterno : string;
    
    apellidoMaterno : string;
    
    nombres : string;
    
    nroLicencia : string;
    
    tipoLicencia : string;
    
    constructor(){
        this.nombres = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.nroLicencia = '';
        this.tipoLicencia = '';
    }

    EsValido(): boolean {
        return (
        this.nombres !== '' &&
        this.apellidoPaterno !== '' &&
        this.apellidoMaterno !== '' &&
        this.nroLicencia !== '' &&
        this.tipoLicencia !== '');
    }
}